import { formatDate, sortValue } from 'utils';
import { priceRender } from 'utils/table';

export const columns = [
  {
    title: 'МРП',
    dataIndex: 'monthly_calculation_indicator',
    key: 'monthly_calculation_indicator',
    sorter: sortValue('monthly_calculation_indicator'),
    render: priceRender,
  },
  {
    title: 'МЗП',
    dataIndex: 'minimal_celery',
    key: 'minimal_celery',
    sorter: sortValue('minimal_celery'),
    render: priceRender,
  },
  {
    title: 'Вычет по ИПН Инвалиды',
    dataIndex: 'pit_invalid',
    key: 'pit_invalid',
    sorter: sortValue('pit_invalid'),
    render: priceRender,
  },
  {
    title: 'Дата начала',
    dataIndex: 'begin_date',
    key: 'begin_date',
    render: (date) => formatDate(date),
  },
  {
    title: 'Дата окончание',
    dataIndex: 'end_date',
    key: 'end_date',
    render: (date) => formatDate(date),
  },
];
